import { render, staticRenderFns } from "./discalculate.vue?vue&type=template&id=1a705cd8&scoped=true&"
import script from "./discalculate.vue?vue&type=script&lang=js&"
export * from "./discalculate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a705cd8",
  null
  
)

export default component.exports